import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Info } from "lucide-react";

export default function InfoTip({ text, side = "top", className = "" }) {
  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        <button type="button" className={`inline-flex items-center justify-center w-4 h-4 rounded-full text-slate-400 hover:text-slate-600 transition-colors ${className}`} data-testid="info-tip">
          <Info className="w-3.5 h-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-[260px] text-xs leading-relaxed bg-evergreen-950 text-white border-0 shadow-lg">
        <p>{text}</p>
      </TooltipContent>
    </Tooltip>
  );
}
